import { atom } from 'jotai';

/**
 * atom 레벨에서 ThemeProvider와 동기화된 값 접근 목적
 */
export const isDarkModeAtom = atom(true);
